
























import Vue from 'vue'
import { BaseContentContainer } from '@/components'
import { OrderDeliveryForm } from './components'
import { createNamespacedHelpers } from 'vuex'
import { STORE_MODULES, ACTIONS_ORDER, ROUTES } from '@/enums'

const { mapActions } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'Start',

    components: { BaseContentContainer, OrderDeliveryForm },

    data: () => ({
        isFetchingOrderCode: false,
    }),

    computed: {
        isMobile(): boolean {
            return this.$vuetify.breakpoint.xsOnly
        },

        queryOrderNumber(): string | undefined {
            return this.$route.query.orderNumber as string
        },

        queryEmail(): string | undefined {
            return this.$route.query.email as string
        },
    },

    async created() {
        if (!this.queryOrderNumber || !this.queryEmail) return

        this.isFetchingOrderCode = true

        try {
            const orderCode = await this.fetchOrderCode({
                email: this.queryEmail,
                orderNumber: this.queryOrderNumber,
            })

            if (orderCode) {
                await this.$router.push({ name: ROUTES.ORDER_DETAILS, params: { orderCode } })
            }
        } catch (error) {}

        this.isFetchingOrderCode = false
    },

    methods: {
        ...mapActions({ fetchOrderCode: ACTIONS_ORDER.FETCH_ORDER_CODE }),
    },
})
